import { render } from "./retailList.vue?vue&type=template&id=772280b3&scoped=true"
import script from "./retailList.vue?vue&type=script&lang=js"
export * from "./retailList.vue?vue&type=script&lang=js"

import "./retailList.vue?vue&type=style&index=0&id=772280b3&scoped=true&lang=css"

import exportComponent from "/Users/cole/Desktop/중요/xz_opr/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-772280b3"]])

export default __exports__